import React from 'react'

interface OTPResendButtonProps {
  resendTimer: number
  isOTPVerificationLimitExceeded: boolean
  isOTPVerificationLoading: boolean
  hideOTPResendText: boolean
  onResendClick: () => void
}

export const OTPResendButton: React.FC<OTPResendButtonProps> = ({
  resendTimer,
  isOTPVerificationLimitExceeded,
  isOTPVerificationLoading,
  hideOTPResendText,
  onResendClick
}) => {
  const getResendMessage = () => {
    if (isOTPVerificationLimitExceeded) {
      return 'OTP limit exhausted'
    }
    if (resendTimer > 0) {
      if (hideOTPResendText) {
        return ''
      } else {
        return `Resend OTP in ${resendTimer}s`
      }
    }
    return 'Resend OTP'
  }

  return (
    <div className='text-center max-w-[210px] mx-auto'>
      {isOTPVerificationLimitExceeded ? (
        <p className='text-[#6A6E6E] text-[14px] font-[500]'>{getResendMessage()}</p>
      ) : resendTimer > 0 ? (
        <p className='text-[#6A6E6E] text-sm'>{getResendMessage()}</p>
      ) : (
        <button
          onClick={onResendClick}
          disabled={isOTPVerificationLoading}
          className='text-[#1470CC] text-[14px] p-0 bg-white font-[500] hover:text-[#1470CC] disabled:text-gray-400 disabled:cursor-not-allowed'
        >
          {getResendMessage()}
        </button>
      )}
    </div>
  )
}
